import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { Text as DreiText } from '@react-three/drei';

const CalculatorModel = (props) => {
  const { isDarkMode = false, ...restProps } = props;
  const calculatorRef = useRef();
  const buttonsRef = useRef([]);
  const screenRef = useRef();

  useFrame((state) => {
    if (calculatorRef.current) {
      calculatorRef.current.rotation.y = Math.sin(state.clock.elapsedTime * 0.3) * 0.1;
    }

    buttonsRef.current.forEach((button, i) => {
      if (button) {
        button.scale.x = 1 + Math.sin(state.clock.elapsedTime * 2 + i) * 0.05;
        button.scale.y = 1 + Math.sin(state.clock.elapsedTime * 2 + i) * 0.05;
      }
    });

    if (screenRef.current) {
      screenRef.current.material.emissiveIntensity = 0.2 + Math.sin(state.clock.elapsedTime * 2) * 0.1;
    }
  });

  const buttonPositions = [
    [-0.6, 0.3, 0.1], [0, 0.3, 0.1], [0.6, 0.3, 0.1],
    [-0.6, -0.1, 0.1], [0, -0.1, 0.1], [0.6, -0.1, 0.1],
    [-0.6, -0.5, 0.1], [0, -0.5, 0.1], [0.6, -0.5, 0.1]
  ];

  return (
    <group {...restProps}>
      <mesh ref={calculatorRef} castShadow>
        <boxGeometry args={[2, 1.5, 0.3]} />
        <meshStandardMaterial
          color={isDarkMode ? "#2d3748" : "#4a5568"}
          metalness={isDarkMode ? 0.8 : 0.6}
          roughness={isDarkMode ? 0.2 : 0.4}
        />
      </mesh>

      <mesh ref={screenRef} position={[0, 0.6, 0.16]}>
        <planeGeometry args={[1.6, 0.4]} />
        <meshStandardMaterial
          color={isDarkMode ? "#1a202c" : "#2d3748"}
          emissive="#A37A00"
          emissiveIntensity={isDarkMode ? 0.3 : 0.2}
        />
      </mesh>

      <DreiText
        position={[0, 0.6, 0.17]}
        fontSize={0.1}
        color="#A37A00"
        anchorX="center"
        anchorY="middle"
      >
        12,450.00
      </DreiText>

      {buttonPositions.map((pos, index) => (
        <mesh
          key={index}
          ref={(el) => (buttonsRef.current[index] = el)}
          position={pos}
          castShadow
        >
          <cylinderGeometry args={[0.15, 0.15, 0.05, 16]} />
          <meshStandardMaterial
            color={index === 8 ? '#A37A00' : (isDarkMode ? '#4a5568' : '#718096')}
            metalness={isDarkMode ? 0.5 : 0.4}
            roughness={isDarkMode ? 0.3 : 0.5}
          />
          <DreiText
            position={[0, 0, 0.03]}
            fontSize={0.08}
            color="white"
            anchorX="center"
            anchorY="middle"
          >
            {['7', '8', '9', '4', '5', '6', '1', '2', '3'][index]}
          </DreiText>
        </mesh>
      ))}

      <mesh position={[0.9, -0.3, 0.16]}>
        <cylinderGeometry args={[0.2, 0.2, 0.05, 16]} />
        <meshStandardMaterial
          color="#A37A00"
          metalness={isDarkMode ? 0.5 : 0.4}
          roughness={isDarkMode ? 0.3 : 0.5}
        />
        <DreiText
          position={[0, 0, 0.03]}
          fontSize={0.1}
          color="white"
          anchorX="center"
          anchorY="middle"
        >
          =
        </DreiText>
      </mesh>
    </group>
  );
};

export default CalculatorModel;